import React, { useEffect, useState } from 'react'
import { postSignup, updateSignup } from '../../redux/ducks/signup';
import { connect } from 'react-redux'
import { Formik,Form, Field } from 'formik';
import { TextField } from 'formik-material-ui';
import { makeStyles, Container, Grid, LinearProgress, Typography, Button } from '@material-ui/core';
import {FormikPersistStore} from '../../component/FormikPersistStore'
import {checkRequiredHandler} from '../../component/FormUtil'
import { Link } from 'react-router-dom';
import { history,MyMess } from '../../App';
import { GlobalSnackBarUtil } from '../../component/GlobalSnackBar';
import {isEmail} from '../../utils/Utils';
import Axios from 'axios';
import {useSelector } from 'react-redux';
import { parseStdResponseError, ResetPassword } from '../../server/WebServiceUrl';

import passwordImage from '../../images/password.png'
import logoImage from '../../images/logo.png'

import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import {GreenButton} from '../../component/colorButton';
import LangChangeSelect from '../../component/LangChangeSelect';
import Footer from '../../component/footer';
import Hidden from '@material-ui/core/Hidden';


const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        alignItems: 'center',
        height: '100vh'
    },
    paper: {
        position:'relative',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        flex: 1
    },
    avatar: {
      margin: theme.spacing(1),
      backgroundColor: theme.palette.secondary.main,
    },
    form: {
      width: '100%', // Fix IE 11 issue.
      marginTop: theme.spacing(3),
    },
    submit: {
      margin: theme.spacing(3, 0, 2),
    },
    landingImage: {
        flex: 1,
        position: 'relative'
      },
      logo: {
        width: '60%'
      },
      cardRoot: {
        minWidth: 345,
        maxWidth: 345,
      },
      langPicker: {
        position: 'absolute',
        top: 15,
        right: 15
      },
      link: {
          color: "#5db4a2",
          '&:visited' :{
            color: "#5db4a2",
          }
      }
  }));

// const checkRequiredHandler = (fields,values,errors) => {
//     fields.forEach(field =>{
//         if(!values[field]){
//             errors[field] = 'Required';
//         }
//     })


//     return errors;
// }

function ForgetPwForm(props) {

    let app = useSelector(state => state.app);
    MyMess.setLanguage(app.lang);
    const classes = useStyles();

    const [formData, setFormData] =useState({
        email:''
    })


    const validateHandler = values => {
        const errors = {};
        // checkRequiredHandler(['email'],values,errors);
      

        if (values.email && !isEmail(values.email)) {
            errors.email = MyMess.general.errors.email
        }

        return errors;
    }

    const submitHandler =(values, { setSubmitting }) => {
        
        async function doReset(){
            let resetPwData = await requestForReset(values.email);
            if(resetPwData.pass){
                //show reset notice
                GlobalSnackBarUtil.open({
                    message:MyMess.general.resetEmailSent               
                })
            }else{
                //show error
                parseStdResponseError(resetPwData);
            } 
            setSubmitting(false);
        }

        doReset();
                   
    }
        

    const updateStoreHandler = (data) => {
        setFormData(data);
    }
    
    const formComponent = () => {

        return (
            <Form className={classes.form}>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                    <Typography className={classes.title} color="textSecondary" gutterBottom>
                        {MyMess.general.resetPwEmail}
                    </Typography>
                    </Grid>
                    <Grid item xs={12}>                
                        <Field                                
                        name="email"
                        type="email"                                
                        render={(props) => 
                            <TextField 
                            variant="outlined"
                            inputProps={{ style: { textTransform: "lowercase" } }}
                            required
                            label={MyMess.general.email}
                            fullWidth {...props}/>}                                       
                            
                        ></Field>
                    </Grid>                            
                    <GreenButton
                        type="submit"
                        fullWidth
                        variant="contained"
                        color="primary"
                        className={classes.submit}
                    >
                        {MyMess.general.confirm}
                    </GreenButton>
                    <Grid container justify="center">
                        <Grid item>
                            <Link to="/login" variant="body2" className={classes.link}>
                                {MyMess.general.returnToLogin}
                            </Link>
                        </Grid>
                    </Grid>
                </Grid>
                <FormikPersistStore name="singUpForm" handler={updateStoreHandler}></FormikPersistStore>
            </Form>            
        )
    }

    return (
        <div>
            <div className="s">
                <div className="a"></div>
                <div className="b"></div>
                <div className="c"></div>
                <div className="d"></div>
            </div>
            <div className={classes.langPicker}>
                <LangChangeSelect variant="" />
            </div>  
            <Formik
            initialValues={formData}        
            validate={validateHandler}
            onSubmit={submitHandler}        
            >
                {({ submitForm, isSubmitting }) => (      
                            
                    <Container component="main" className={classes.root} maxWidth="xl">
                        {isSubmitting  && <LinearProgress />}
                        <div className={classes.paper}>
                            <Card className={classes.cardRoot} raised={true}>
                                <CardHeader
                                title={<img src={logoImage} className={classes.logo}/>}
                                />
                                <CardContent>
                                <Typography component="h5" variant="h5">
                                    {MyMess.general.forgotPasswordTitle}
                                </Typography>
                                {formComponent()}
                                </CardContent>
                            </Card>
                        </div>
                        <Hidden only={['xs', 'sm']}>
                            <div className={classes.landingImage}>
                                <img src={passwordImage}  />
                            </div>
                        </Hidden>
                    </Container>
                )}
            </Formik>
            <Footer />
        </div>
        
    )
}

async function requestForReset(email){
    let result = {
        data:{}
    }
    try{
        result = await Axios.post(ResetPassword,{email:email});
    }catch(e){
        if(e.response){
            result.data = e.response.data
        }
    }

    return result.data;

    
}

export default ForgetPwForm;